<script lang="ts">
  import type { GroupedTransaction } from "../../../../api/transactions";
  import ToggleButton from "../../../buttons/ToggleButton.svelte";
  import DatePanelHeader from "../DatePanelHeader.svelte";
  import OrderProductsTable from "../OrderProductsTable.svelte";

  export let transaction: GroupedTransaction;
  export let selected: boolean = false;
  export let didSelect: (transaction?: GroupedTransaction) => void;

  function onToggle() {
    if (selected) {
      didSelect(undefined);
    } else {
      didSelect(transaction);
    }
  }

  $: title = `order ${transaction.po_number} - ${transaction.line_item_count} items`;
  $: subtitle = transaction.confirmed_by && `confirmed by ${transaction.confirmed_by}`;
  $: date = new Date(transaction.invoice_date || new Date());
</script>

<div class="container">
  <div class="header">
    <DatePanelHeader {date} {title} {subtitle} />
    <ToggleButton size={56} {onToggle} active={selected} />
  </div>

  <div class="content">
    <OrderProductsTable items={transaction.order_items ?? []} collapseAt={4} />
  </div>
</div>

<style>
  .container {
    background-color: var(--rekki-light);
    width: 100%;
    padding: 16px 16px 0 16px;
  }

  .header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

  .content {
    flex: 1;
    border-top: solid 1px var(--rk-divider-0);
    margin-top: 16px;
  }
</style>
